export default __webpack_public_path__ + "static/media/favorites-booty.07505c58.png";